<div class="container" [formGroup]="formGroup">
  <pdq-card variant="popover" color="white">
    <div class="card-content">
      <div><pdq-heading element="h6">Token for Shopify</pdq-heading></div>
      <pdq-divider></pdq-divider>
      <div>
        <pdq-link
          label="View detailed installation instructions"
          [external]="true"
          url="https://support.prettydamnquick.com/en/articles/16627307-setting-up-order-protection-in-checkout"></pdq-link>
        <pdq-input
          [readonly]="true"
          formControlName="usageToken"
          label="Paste into the 'Order Protection token' field of the PDQ extension"
          [clipboard]="true"></pdq-input>
        <pdq-extension-preview-token [usageTokenControl]="formGroup.get('usageToken')"></pdq-extension-preview-token>
        @if (partnerApplicationId) {
          <pdq-input
            [value]="partnerApplicationId"
            [readonly]="true"
            label="Paste into the 'Application ID' field of the Order Protection extension"
            [clipboard]="true"></pdq-input>
        }
      </div>
    </div>
  </pdq-card>

  <pdq-card variant="popover" color="white">
    <div class="card-content">
      <div><pdq-heading element="h6">General</pdq-heading></div>
      <pdq-divider></pdq-divider>
      <div>
        <pdq-input
          label="Internal name"
          formControlName="internalName"
          [invalid]="formGroup.controls.internalName.touched && formGroup.controls.internalName.hasError('required')"
          invalidMsg="Internal name is required"></pdq-input>
        <pdq-input label="Internal description" formControlName="internalDescription"></pdq-input>
      </div>
    </div>
  </pdq-card>

  <pdq-card variant="popover" color="white">
    <div class="card-content">
      <div class="section-header">
        <pdq-heading element="h6">Protection product</pdq-heading>
        <span class="section-subtitle">The Order Protection product shoppers are charged for.</span>
      </div>
      <pdq-divider></pdq-divider>
      <div>
        @switch (productView?.state) {
          @case ('found') {
            <pdq-product-list
              [products]="products"
              [currencySymbol]="''"
              [showSearch]="false"
              [showRemove]="false"
              [showEdit]="false"
              [showDragHandle]="false"
              [showPagination]="false"
              [showExternalLink]="true"
              (externalLink)="onExternalLink($event)"></pdq-product-list>
          }
          @case ('loading') {
            <span class="protection-product__note">Resolving product…</span>
          }
          @case ('not_connected') {
            <pdq-banner
              variant="info"
              bannerTitle="Connect Order Protection"
              content="The Order Protection app is installed. Connect it to load the protection product."
              button="Manage Integrations"
              [plainButton]="true"
              variantButton="light"
              [closable]="false"
              (onButtonClick)="navigateToIntegrations()"></pdq-banner>
          }
          @case ('not_found') {
            <pdq-banner
              variant="attention"
              bannerTitle="Order Protection isn’t set up yet"
              content="It needs the Order Protection app installed in Shopify, then connected as an integration."
              button="Manage Integrations"
              [plainButton]="true"
              variantButton="light"
              [closable]="false"
              (onButtonClick)="navigateToIntegrations()"></pdq-banner>
          }
        }
      </div>
    </div>
  </pdq-card>

  <pdq-card variant="popover" color="white">
    <div class="card-content">
      <div class="section-header">
        <pdq-heading element="h6">Protection behavior</pdq-heading>
        <span class="section-subtitle">How the protection option appears to the shopper.</span>
      </div>
      <pdq-divider></pdq-divider>
      <div>
        <pdq-radio-group formControlName="automaticallyAddToCart" variant="card">
          <pdq-radio-button
            [value]="true"
            text="Auto-select"
            subText="Protection is pre-selected; the shopper can opt out."></pdq-radio-button>
          <pdq-radio-button
            [value]="false"
            text="Opt-in"
            subText="Protection is off by default; the shopper opts in."></pdq-radio-button>
        </pdq-radio-group>
      </div>
    </div>
  </pdq-card>
</div>
